import React from 'react';

const StarIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 0.78125L11.1394 7.39547H18L12.5151 11.5465L14.6688 18.2188L9 14.1059L3.33116 18.2188L5.4849 11.5465L0 7.39547H6.86059L9 0.78125ZM10.3209 8.52047L9 4.43638L7.67909 8.52047L3.35025 8.52013L6.80096 11.1317L5.46075 15.2836L9 12.716L12.5387 15.2836L11.199 11.1317L14.6492 8.52013L10.3209 8.52047Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default StarIcon;
